export const routes = {
  login: {
    path: '/login',
    name: 'login'
  },
  dashboard: { name: 'Dashboard', path: '/dashboard' },
  innovation: { name: 'inno_navbar.module_name', path: '/innovation' },
  monitoring: { name: 'Monitoring', path: '/monitoring/:barcode/:format' },
  contact: { name: 'inno_navbar.gitbook_button', path: '#' },
  forbidden: { name: 'Forbidden', path: '/forbidden' }
};

export default routes;
